import { render } from "./RatioPage.vue?vue&type=template&id=52098df9&ts=true"
import script from "./RatioPage.vue?vue&type=script&lang=ts"
export * from "./RatioPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__